import { useEffect, useState } from 'react';
import EfLink from '../ef-link';
import { signupCookie } from '@/utils/cookies/signupCookie';

export default function BuyLinkNoLogin({ prefixCls, locale, textA, item }: { prefixCls: string; locale: string; textA: any; item: any }) {
    const loginPath1 = `/${locale}/login`;
    const [loginPath, setLoginPath] = useState(loginPath1);
    const loginText = item.loginText || textA.loginText;
    const saveScrollPosition = () => {
        sessionStorage.setItem('scrollPosition', String(document.documentElement.scrollTop));
        signupCookie({ sector_name: 'bundles', entry_position: 0 });
    };

    useEffect(() => {
        const pathname2 = location.pathname;
        setLoginPath(`${loginPath1}?redirect=${pathname2}`);
    }, []);

    return (
        <EfLink className={`${prefixCls}-link ${prefixCls}-no-login`} href={loginPath} onClick={saveScrollPosition}>
            {loginText}
        </EfLink>
    );
}
